// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__TL9Uz","mail__wrapper":"Footer_mail__wrapper__5rQck","materials__wrapper":"Footer_materials__wrapper__5y3Or","code__wrapper":"Footer_code__wrapper__R21N0"};